import { ERROR_CODES } from '@dealstack/shared/lib/common/errors';
import { isStandardBackendError } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { getBackendErrorMessage } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';

const START_DATE_ERROR_CODES = new Set<number>([
	ERROR_CODES.PROJECT.MIP.MANAGE.VESTING[11020601],
	ERROR_CODES.PROJECT.MIP.MANAGE.VESTING[11020602],
]);

/** The server's sentence for an out-of-window start date, which carries the allowed date. */
export const getStartDateError = (error: unknown): string | undefined =>
	isStandardBackendError(error) && START_DATE_ERROR_CODES.has(error.error.code)
		? getBackendErrorMessage(error)
		: undefined;
